import { useQuery } from '@pinia/colada';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import activityFeedService from '../services/activity-feed.service';

/**
 * Prefix shared by every activity-feed query, so invalidating it refreshes the owner, property and
 * renter feeds at once - an investor action shows up in whichever of them is on screen.
 */
export function getActivityFeedRootQueryKey() {
  return ['activity-feed'];
}

export function getActivityFeedQueryKey() {
  return getActivityFeedRootQueryKey();
}

export function useActivityFeedQuery() {
  return useQuery({
    key: () => getActivityFeedQueryKey(),
    query: () => activityFeedService.getList({ limit: 50 }),
  });
}

export function getPropertyActivityFeedQueryKey(propertyId: string) {
  return ['activity-feed', 'property', propertyId];
}

export function usePropertyActivityFeedQuery() {
  const route = useRoute();
  const propertyId = computed(() => route.params.propertyId as string);

  return useQuery({
    key: () => getPropertyActivityFeedQueryKey(propertyId.value),
    query: () => activityFeedService.getPropertyList(propertyId.value, { limit: 50 }),
  });
}

export function getRenterActivityFeedQueryKey(renterId: string) {
  return ['activity-feed', 'renter', renterId];
}

export function useRenterActivityFeedQuery() {
  const route = useRoute();
  const renterId = computed(() => route.params.renterId as string);

  return useQuery({
    key: () => getRenterActivityFeedQueryKey(renterId.value),
    query: () => activityFeedService.getRenterList(renterId.value, { limit: 50 }),
  });
}
